
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
Group,
Cell
},
data() {
return {
id: this.$route.query.id,
outlineList: []
};
},
created() {
this.getData();
},
methods: {
getData() {
this.id = this.$route.query.id;

this.$vux.loading.show({
text: "请稍候..."
});

this.loadCourseOutlineList(this.id);
},
onOutLine(outline) {
if (outline.bendgrade) {
if (outline.itype == 0) {
window.location.href = outline.curl;
} else {
this.$router.push({
path: "/CourseOutlineData",
query: { id: outline.ioutlineid }
});
}
} else {
this.$router.push({
path: "/CourseOutlineList",
query: {
id: outline.ioutlineid
}
});
}
},
loadCourseOutlineList(parentId) {
this.$http({
method: "post",
url: "wxexam.ashx?op=LoadCourseOutlineList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
type: 0,
parentId: parentId
}
})
.then(response => {
if (response.status == 200) {
this.outlineList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
}
},
watch: {
$route: "getData"
}
};



// WEBPACK FOOTER //
// ./src/components/CourseOutlineList.vue